import React from "react";
import Insights from "@/components/Insights";

export default function InsightsPage() {
  return (
    <div className="pt-24" data-testid="page-insights">
      <Insights />
    </div>
  );
}
